import { SHRINKMD_URL, networkUrl } from "@/lib/site";
import type { CSSProperties, ReactNode } from "react";

type Props = {
  children?: ReactNode;
  label?: string;
  style?: CSSProperties;
  className?: string;
};

export default function ShrinkMDLink({ children, label, style, className }: Props) {
  return (
    <a
      href={networkUrl(SHRINKMD_URL, "care")}
      target="_blank"
      rel="noopener noreferrer"
      style={style}
      className={className}
    >
      {children ?? label ?? "shrinkMD"}
    </a>
  );
}
